module.exports = __webpack_public_path__ + "media/images/pc/specials/common/reserve_present-061dfedddd3389805ae220eecb434342.svg";